import React, { useEffect } from 'react';

import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import servicioHttp from '../../servicio/ServicioHttp';

export const ModalEliminarEmpresa = (props) => {

    const { empresaEliminar, mostrarModal, funcionCerrarModal } = props;

    useEffect(() => {

    }, [empresaEliminar]);

    const cerrarModal = () => {
        funcionCerrarModal();
    }

    const eliminar = () => {
        const empresa = {};
        empresa.id = empresaEliminar.id;
        empresa.estado = empresaEliminar.estado === 0 ? 1 : 0;
        servicioHttp.consumirPostHttp('empresa/suspender.json', empresa).then(response => {
            funcionCerrarModal();
        }).catch(error => {

        });
    }


    const dialogFooterConfirmacionEliminar = (
        <div>
            <Button
                icon="pi-md-check"
                onClick={eliminar}
                label="Si estoy seguro" />
            <Button
                icon="pi-md-close"
                onClick={cerrarModal}
                label="No estoy seguro"
                className="p-button-danger flat-btn" />
        </div>
    );

    return (
        <div>

            <Dialog
                header="Confirmación"
                visible={mostrarModal}
                modal={true}
                appendTo={document.body}
                footer={dialogFooterConfirmacionEliminar}
                onHide={cerrarModal}>
                <h2>¿Estás seguro que quieres {empresaEliminar.estado === 0 ? 'Desactivar' : 'Activar'} la empresa con registro patronal {empresaEliminar.registroPatronal}?</h2>
            </Dialog>
        </div>
    );
}